import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";

const savedLang = localStorage.getItem("lang"); // previously selected language
const browserLang = navigator.language || navigator.userLanguage; // browser default

// determine initial language: saved > browser > fallback
const initialLang =
  savedLang ||
  (browserLang && browserLang.toLowerCase().startsWith("zh")
    ? "zh"
    : "en");

i18n
  .use(Backend) // load translations via HTTP from /public/locales
  .use(initReactI18next) // connect i18n with React
  .init({
    lng: initialLang, // initial language
    fallbackLng: "en", // fallback if key missing

    ns: ["common", "home", "hobbies"], // namespaces to preload
    defaultNS: "common", // default namespace when none specified

    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json" // path to translation files
    },

    interpolation: {
      escapeValue: false // React already escapes output
    }
  });

  // Keep <html lang=""> in sync with i18n so CSS :lang() selectors (e.g., Chinese fonts) work correctly
  document.documentElement.lang = i18n.language;

  i18n.on("languageChanged", (lng) => {
    document.documentElement.lang = lng;
  });

export default i18n;